/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-06-19 11:03:44
 * @modify date 2023-06-19 11:03:44
 * @desc [description]
 */



import { Modal, View, StyleSheet, Pressable, Text } from "react-native";
import { ReactComponent as ImgBtnCloseWhite } from '../../../img/btn-close-white.svg'
import { useTranslation } from "react-i18next";
import { FONT } from "value/staticValues";
import { useState } from "react";

import { ReactComponent as RowSelectCheckBoxInactiveImg } from "../../../img/btn-checkbox-incon-circle-inactive.svg";
import { ReactComponent as RowSelectCheckBoxActiveImg } from "../../../img/btn-checkbox-incon-circle-active.svg";
import { CustomTextInput } from "components/base/CustomInputText";


interface IBasicPopupModalProps {
  showPopupYn: boolean
  closeBtnCb: ()=>void;
  // cancelBtn은 Function 이 아닌, boolean 으로 받아도 무방 함. (현재는 단순 취소 기능만 사용)
  // 하지만 추후 취소 버튼의 텍스트 또는 기능 변경 시를 대비하기 위해 Function으로 받음
  cancelBtnCb: ()=>void;
  confirmBtnCb: (location:string, path:string)=>void;
}


export default function BackupSyncModal(props:IBasicPopupModalProps) {
  const { t } = useTranslation();
  const [location, setLocation] = useState<"remote"|"local">("remote");
  const [path, setPath] = useState("");

  return (
    <Modal transparent={true} visible={props.showPopupYn} animationType={'fade'}>
      <View style={style.mainContainer}>
        <View style={{width:400, height:262, borderWidth:1, borderColor:"#e6e6e6", borderRadius:12, backgroundColor:"#ffffff", shadowColor:"#d8d8d81a", shadowRadius:5, shadowOffset:{width:0, height:2}}}>

          {/* 닫기 버튼 */}
          <Pressable
            style={{width:50, height:50, alignSelf:"flex-end", paddingRight: 30, paddingTop: 15}}
            onPress={() => {
              setLocation("remote")
              setPath("")
              props.closeBtnCb()
            }}>
            <ImgBtnCloseWhite/>
          </Pressable>


          {/* title */}
          <View style={{marginLeft:40, marginBottom:20}}>
            <Text style={style.titleTextStyle}>
              {t("BACKUP_MGMT_SYNC_POPUP_TITLE")}
            </Text>
          </View>


          {/* 위치 */}
          <View style={{flexDirection:"row", marginLeft:40, alignItems:"center", marginBottom:20}}>
            <Text style={[style.descTextStyle, {marginRight:80}]}>{t("BACKUP_MGMT_SYNC_POPUP_LOCATION")}</Text>
            <Text style={[style.descTextStyle, {marginRight:10}]}>{t("REMOTE_TEXT")}</Text>
            <Pressable onPress={()=>setLocation("remote")}>
              { location === "remote" ? <RowSelectCheckBoxActiveImg/> : <RowSelectCheckBoxInactiveImg/> }
            </Pressable>
            <Text style={[style.descTextStyle, {marginLeft:20, marginRight:10}]}>{t("LOCAL_TEXT")}</Text>
            <Pressable onPress={()=>setLocation("local")}>
              { location === "local" ? <RowSelectCheckBoxActiveImg/> : <RowSelectCheckBoxInactiveImg/> }
            </Pressable>
          </View>


          {/* 저장소 Path */}
          <View style={{flexDirection:"row", marginLeft:40, alignItems:"center"}}>
            <Text style={[style.descTextStyle, {marginRight:35}]}>
              {t("BACKUP_MGMT_SYNC_POPUP_PATH")}
            </Text>
            <CustomTextInput
              key={1}
              width={200} height={36}
              value={path}
              type={"text"}
              activeYn={true}
              inputCb={setPath}
              warnYn={false}
              placeHolderText={t("PATH_ENTER_MESSAGE")}
            />
          </View>



          {/* Buttons */}
          <View style={style.buttonContainer}>

            {/* Cancel Button */}
            {
              <Pressable style={style.buttonCancelContainer}
              onPress={() => {
                setLocation("remote")
                setPath("")
                props.cancelBtnCb();
              }}>
                <Text style={style.buttonCancelTextStyle}>
                  {t("CANCEL_TEXT")}
                </Text>
              </Pressable>
            }


            {/* Confirm or Remove Button */}
            <Pressable style={style.buttonConfirmContainer}
            onPress={() => {
              props.confirmBtnCb(location, path);
              setLocation("remote")
              setPath("")
            }}>
              <Text style={style.buttonConfirmTextStyle}>
                {t("SYNC_TEXT")}
              </Text>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  )
}




const style = StyleSheet.create({
  mainContainer: {
    flex: 1,
    alignItems: 'center',
    height: '100vh',
    minWidth: 1920,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    paddingTop: 240
    // justifyContent: "center"
  },
  closeBtnStyle: {
    height: 50,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 30
  },
  titleContainer: {
    width: "100%",
    height: 20,
    marginTop: 2,
    justifyContent: "center",
    alignItems: "center"
  },
  titleTextStyle: {
    flex: 1,
    fontSize: 15,
    lineHeight: 22,
    color: '#333333',
    fontFamily: FONT.MEDIUM
  },
  descContainer: {
    flexDirection:"row",
    width: "100%",
    height: 44,
    marginTop: 8,
    justifyContent: "center",
    alignItems: "center",
  },
  descTextStyle: {
    fontSize: 14,
    lineHeight: 22,
    color: '#333333',
    fontFamily: FONT.REGULAR,
    textAlign: "center"
  },
  buttonContainer: {
    width: "100%",
    height: 98,
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingBottom: 30,
    paddingRight: 30,
    flexDirection: "row"
  },
  buttonCancelContainer: {
    width: 70,
    height: 36,
    borderRadius: 10,
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: '#d4d9db',
    justifyContent: "center",
    alignItems: "center"
  },
  buttonCancelTextStyle: {
    fontSize: 12,
    lineHeight: 10,
    color: '#a6a6a6',
    fontFamily: FONT.MEDIUM,
  },
  buttonConfirmContainer: {
    width: 70,
    height: 36,
    borderRadius: 10,
    borderStyle: "solid",
    backgroundColor: '#4f5fd8',
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 10
  },
  buttonConfirmTextStyle: {
    fontSize: 12,
    lineHeight: 10,
    color: '#ffffff',
    fontFamily: FONT.MEDIUM,
  }
})